import type {FunctionComponent} from 'react';
import {useTranslation} from '@app/hooks/use-translation';
import {
	LandingHeading,
	LandingStepper,
	LandingStepperItem,
	LandingParagraph,
	LandingSection,
} from '@tempo/landing';
import {HeartOutlinedIcon, NotePlusIcon, HumansIcon} from '@tempo/icons';
import {LandingButtonLink} from '@app/components/landing-btn-link';

export const Stepper: FunctionComponent = () => {
	const {t} = useTranslation();
	return (
		<LandingSection
			isContained
			description={
				<>
					<LandingHeading as="h1">
						{t(
							'shakerearlyaccesslanding_title_mixtasteswithfriends_standalone-web',
							{ns: 'shaker'},
						)}
					</LandingHeading>
					<LandingParagraph>
						{t(
							'shakerearlyaccesslanding_text_friendsformanyplatform_standalone-web',
							{ns: 'shaker'},
						)}
					</LandingParagraph>
					<LandingButtonLink
						tracking={{eventaction: 'discover'}}
						target="_blank"
						href="https://link.deezer.com/?dest=https%3A%2F%2Fwww.deezer.com%2Fmusictogether%2Fgroups&amv=8.0.34&imv=10.34.0&gwf=https%3A%2F%2Fshaker.deezer.com%2Fgroups"
						isMain
					>
						{t('musictogether_action_tryshaker_standalone-web', {
							ns: 'common',
						})}
					</LandingButtonLink>
				</>
			}
		>
			<LandingStepper>
				<LandingStepperItem
					step={<NotePlusIcon boxSize={8} color="black.500" />}
				>
					{t('shakerbenefit_text_generateplayliststogether_standalone-web', {
						ns: 'shaker',
					})}
				</LandingStepperItem>
				<LandingStepperItem
					step={<HeartOutlinedIcon boxSize={8} color="black.500" />}
				>
					{t('shakerbenefit_text_discoverfriendslovedtracks_standalone-web', {
						ns: 'shaker',
					})}
				</LandingStepperItem>
				<LandingStepperItem step={<HumansIcon boxSize={8} color="black.500" />}>
					{t('shakerbenefit_text_checkcompatibilitylevels_standalone-web', {
						ns: 'shaker',
					})}
				</LandingStepperItem>
			</LandingStepper>
		</LandingSection>
	);
};
